import { isToday } from 'date-fns/isToday';
// import { isTomorrow } from 'date-fns/isTomorrow';
import { format } from 'date-fns/format';
import { useMemo } from 'react';

const defaultOptions = {
  includeOnline: false,
  dateFormatCapitalized: true,
};

const getNextAvailableTime = (date: Date, { includeOnline = false, dateFormatCapitalized = true } = defaultOptions) => {
  const hasMinutes = date.getMinutes() !== 0;
  const dateFormat = dateFormatCapitalized ? (hasMinutes ? 'h:mma' : 'ha') : hasMinutes ? 'h:mmaaa' : 'haaa';

  switch (true) {
    case isToday(date): {
      return format(date, `'Back ${includeOnline ? 'online' : ''} at' ${dateFormat}`);
    }
    // case isTomorrow(date): {
    //   return format(date, `'Back tomorrow at' ${dateFormat}`);
    // }
    default: {
      return format(date, `'Back ${includeOnline ? 'online' : ''}' EEE 'at' ${dateFormat}`);
    }
  }
};

export default function useNextAvailableTime(
  nextDate: string,
  { includeOnline = false, dateFormatCapitalized = true } = defaultOptions
) {
  return useMemo(() => {
    if (!nextDate) return 'Back later';

    const date = new Date(nextDate);
    return getNextAvailableTime(date, { includeOnline, dateFormatCapitalized });
  }, [nextDate, includeOnline, dateFormatCapitalized]);
}
